// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"ResourcePage_pageWrap__aHgwk"};